{
  "version": 1,
  "asset_id": "49ff11d0-1f3e-4b7b-b519-1663a2149373",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/49ff11d0-1f3e-4b7b-b519-1663a2149373/esenyurt-hizli-elektrikci-7-24-dukkan-6.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/49ff11d0-1f3e-4b7b-b519-1663a2149373/esenyurt-hizli-elektrikci-7-24-dukkan-6.jpg",
  "original_filename": "esenyurt-hizli-elektrikci-7-24-dukkan-6.jpg",
  "size": 602448,
  "content_type": "image/jpeg",
  "created_at": "2026-09-12T10:56:18Z"
}
